module.exports = __webpack_public_path__ + "img/C07TechBowmanChampion_ua.ff9d0e18.webp";